import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ClipboardListIcon, TruckIcon, PackageIcon, DollarSignIcon, UserIcon, SearchIcon, FilterIcon, CalendarIcon, CheckCircleIcon, XCircleIcon, Clock8Icon, ShoppingBagIcon, AlertCircleIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
const OrderManagement = () => {
  const [activeTab, setActiveTab] = useState('all');
  const orders = [{
    id: 'ORD-2023-7845',
    customer: 'John Smith',
    items: 3,
    total: '$1,249.97',
    status: 'Processing',
    date: '2023-07-20',
    paymentStatus: 'Paid',
    shippingMethod: 'Express'
  }, {
    id: 'ORD-2023-7844',
    customer: 'Emma Johnson',
    items: 1,
    total: '$449.99',
    status: 'Shipped',
    date: '2023-07-19',
    paymentStatus: 'Paid',
    shippingMethod: 'Standard'
  }, {
    id: 'ORD-2023-7843',
    customer: 'Michael Brown',
    items: 2,
    total: '$899.98',
    status: 'Delivered',
    date: '2023-07-18',
    paymentStatus: 'Paid',
    shippingMethod: 'Express'
  }, {
    id: 'ORD-2023-7842',
    customer: 'Sophia Martinez',
    items: 1,
    total: '$379.99',
    status: 'Cancelled',
    date: '2023-07-17',
    paymentStatus: 'Refunded',
    shippingMethod: 'Standard'
  }, {
    id: 'ORD-2023-7841',
    customer: 'William Davis',
    items: 4,
    total: '$1,599.96',
    status: 'Processing',
    date: '2023-07-16',
    paymentStatus: 'Paid',
    shippingMethod: 'Express'
  }];
  const orderStats = {
    totalOrders: 124,
    processing: 18,
    shipped: 42,
    delivered: 58,
    cancelled: 6,
    totalRevenue: '$52,845.75'
  };
  return <div className="space-y-6" data-id="element-1186">
      <div className="flex items-center justify-between" data-id="element-1187">
        <div data-id="element-1188">
          <h1 className="text-2xl font-bold" data-id="element-1189">Order Management</h1>
          <p className="text-sm text-muted-foreground" data-id="element-1190">
            Track and manage customer orders, shipments, and returns
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-1191">
          <Button variant="outline" data-id="element-1192">
            <FilterIcon className="mr-2 h-4 w-4" data-id="element-1193" />
            Filter
          </Button>
          <Button data-id="element-1194">
            <ShoppingBagIcon className="mr-2 h-4 w-4" data-id="element-1195" />
            New Order
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1196">
        <Card data-id="element-1197">
          <CardContent className="p-4" data-id="element-1198">
            <div className="flex items-center justify-between" data-id="element-1199">
              <div data-id="element-1200">
                <p className="text-sm text-muted-foreground" data-id="element-1201">Total Orders</p>
                <p className="text-2xl font-bold" data-id="element-1202">{orderStats.totalOrders}</p>
              </div>
              <ClipboardListIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-1203" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-1204">
          <CardContent className="p-4" data-id="element-1205">
            <div className="flex items-center justify-between" data-id="element-1206">
              <div data-id="element-1207">
                <p className="text-sm text-muted-foreground" data-id="element-1208">Processing</p>
                <p className="text-2xl font-bold" data-id="element-1209">{orderStats.processing}</p>
              </div>
              <Clock8Icon className="h-8 w-8 text-muted-foreground/30" data-id="element-1210" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-1211">
          <CardContent className="p-4" data-id="element-1212">
            <div className="flex items-center justify-between" data-id="element-1213">
              <div data-id="element-1214">
                <p className="text-sm text-muted-foreground" data-id="element-1215">Shipped</p>
                <p className="text-2xl font-bold" data-id="element-1216">{orderStats.shipped}</p>
              </div>
              <TruckIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-1217" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-1218">
          <CardContent className="p-4" data-id="element-1219">
            <div className="flex items-center justify-between" data-id="element-1220">
              <div data-id="element-1221">
                <p className="text-sm text-muted-foreground" data-id="element-1222">Total Revenue</p>
                <p className="text-2xl font-bold" data-id="element-1223">{orderStats.totalRevenue}</p>
              </div>
              <DollarSignIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-1224" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-1225">
        <CardHeader className="pb-2" data-id="element-1226">
          <div className="flex items-center justify-between" data-id="element-1227">
            <CardTitle data-id="element-1228">Order List</CardTitle>
            <div className="flex space-x-2" data-id="element-1229">
              <div className="relative" data-id="element-1230">
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-1231" />
                <input type="text" placeholder="Search orders..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-64" data-id="element-1232" />
              </div>
              <Button variant="outline" size="icon" data-id="element-1233">
                <CalendarIcon className="h-4 w-4" data-id="element-1234" />
              </Button>
            </div>
          </div>
          <CardDescription data-id="element-1235">View and manage all customer orders</CardDescription>
        </CardHeader>
        <CardContent data-id="element-1236">
          <Tabs defaultValue="all" value={activeTab} onValueChange={setActiveTab} data-id="element-1237">
            <TabsList className="mb-4" data-id="element-1238">
              <TabsTrigger value="all" data-id="element-1239">All Orders</TabsTrigger>
              <TabsTrigger value="processing" data-id="element-1240">Processing</TabsTrigger>
              <TabsTrigger value="shipped" data-id="element-1241">Shipped</TabsTrigger>
              <TabsTrigger value="delivered" data-id="element-1242">Delivered</TabsTrigger>
              <TabsTrigger value="cancelled" data-id="element-1243">Cancelled</TabsTrigger>
            </TabsList>
            <TabsContent value="all" className="space-y-4" data-id="element-1244">
              <div className="overflow-x-auto" data-id="element-1245">
                <table className="w-full" data-id="element-1246">
                  <thead data-id="element-1247">
                    <tr className="border-b" data-id="element-1248">
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1249">
                        Order ID
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1250">
                        Customer
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1251">
                        Items
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1252">
                        Total
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1253">
                        Status
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1254">
                        Date
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-1255">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-1256">
                    {orders.map(order => <tr key={order.id} className="border-b hover:bg-muted/50" data-id="element-1257">
                        <td className="py-3 px-4 font-medium" data-id="element-1258">{order.id}</td>
                        <td className="py-3 px-4" data-id="element-1259">{order.customer}</td>
                        <td className="py-3 px-4 text-center" data-id="element-1260">{order.items}</td>
                        <td className="py-3 px-4 font-medium" data-id="element-1261">{order.total}</td>
                        <td className="py-3 px-4" data-id="element-1262">
                          <Badge variant={order.status === 'Delivered' ? 'success' : order.status === 'Shipped' ? 'default' : order.status === 'Processing' ? 'warning' : 'destructive'} data-id="element-1263">
                            {order.status}
                          </Badge>
                        </td>
                        <td className="py-3 px-4 text-sm" data-id="element-1264">{order.date}</td>
                        <td className="py-3 px-4" data-id="element-1265">
                          <div className="flex space-x-2" data-id="element-1266">
                            <Button variant="ghost" size="sm" data-id="element-1267">
                              View
                            </Button>
                            <Button variant="outline" size="sm" data-id="element-1268">
                              Update
                            </Button>
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </TabsContent>
            <TabsContent value="processing" data-id="element-1269">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1270">
                <p className="text-muted-foreground" data-id="element-1271">
                  Processing orders will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="shipped" data-id="element-1272">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1273">
                <p className="text-muted-foreground" data-id="element-1274">
                  Shipped orders will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="delivered" data-id="element-1275">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1276">
                <p className="text-muted-foreground" data-id="element-1277">
                  Delivered orders will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="cancelled" data-id="element-1278">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1279">
                <p className="text-muted-foreground" data-id="element-1280">
                  Cancelled orders will be displayed here
                </p>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
        <CardFooter className="border-t" data-id="element-1281">
          <div className="text-sm text-muted-foreground" data-id="element-1282">
            Showing 5 of {orderStats.totalOrders} orders
          </div>
          <div className="ml-auto flex space-x-2" data-id="element-1283">
            <Button variant="outline" size="sm" disabled data-id="element-1284">
              Previous
            </Button>
            <Button variant="outline" size="sm" data-id="element-1285">
              Next
            </Button>
          </div>
        </CardFooter>
      </Card>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1286">
        <Card data-id="element-1287">
          <CardHeader data-id="element-1288">
            <CardTitle data-id="element-1289">Recent Shipments</CardTitle>
            <CardDescription data-id="element-1290">
              Track the latest shipments and deliveries
            </CardDescription>
          </CardHeader>
          <CardContent data-id="element-1291">
            <div className="space-y-4" data-id="element-1292">
              <div className="flex items-start p-3 border rounded-md" data-id="element-1293">
                <TruckIcon className="h-5 w-5 text-blue-500 mr-3 mt-0.5" data-id="element-1294" />
                <div data-id="element-1295">
                  <div className="flex items-center" data-id="element-1296">
                    <p className="font-medium" data-id="element-1297">Order #ORD-2023-7844</p>
                    <Badge className="ml-2" variant="outline" data-id="element-1298">
                      In Transit
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-1299">
                    Estimated delivery: July 22, 2023
                  </p>
                </div>
              </div>
              <div className="flex items-start p-3 border rounded-md" data-id="element-1300">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5" data-id="element-1301" />
                <div data-id="element-1302">
                  <div className="flex items-center" data-id="element-1303">
                    <p className="font-medium" data-id="element-1304">Order #ORD-2023-7843</p>
                    <Badge className="ml-2" variant="outline" data-id="element-1305">
                      Delivered
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-1306">
                    Delivered on: July 19, 2023
                  </p>
                </div>
              </div>
              <div className="flex items-start p-3 border rounded-md" data-id="element-1307">
                <AlertCircleIcon className="h-5 w-5 text-yellow-500 mr-3 mt-0.5" data-id="element-1308" />
                <div data-id="element-1309">
                  <div className="flex items-center" data-id="element-1310">
                    <p className="font-medium" data-id="element-1311">Order #ORD-2023-7841</p>
                    <Badge className="ml-2" variant="outline" data-id="element-1312">
                      Processing
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-1313">
                    Awaiting shipment
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-1314">
          <CardHeader data-id="element-1315">
            <CardTitle data-id="element-1316">Order Issues</CardTitle>
            <CardDescription data-id="element-1317">
              Manage problems with recent orders
            </CardDescription>
          </CardHeader>
          <CardContent data-id="element-1318">
            <div className="space-y-4" data-id="element-1319">
              <div className="flex items-start p-3 border rounded-md bg-red-50 dark:bg-red-900/20" data-id="element-1320">
                <XCircleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5" data-id="element-1321" />
                <div data-id="element-1322">
                  <div className="flex items-center" data-id="element-1323">
                    <p className="font-medium" data-id="element-1324">Order #ORD-2023-7842</p>
                    <Badge className="ml-2" variant="destructive" data-id="element-1325">
                      Cancelled
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-1326">
                    Customer requested cancellation
                  </p>
                  <Button variant="outline" size="sm" className="mt-2" data-id="element-1327">
                    Process Refund
                  </Button>
                </div>
              </div>
              <div className="flex items-start p-3 border rounded-md bg-yellow-50 dark:bg-yellow-900/20" data-id="element-1328">
                <AlertCircleIcon className="h-5 w-5 text-yellow-500 mr-3 mt-0.5" data-id="element-1329" />
                <div data-id="element-1330">
                  <div className="flex items-center" data-id="element-1331">
                    <p className="font-medium" data-id="element-1332">Order #ORD-2023-7840</p>
                    <Badge className="ml-2" variant="warning" data-id="element-1333">
                      Payment Issue
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-1334">
                    Payment authorization failed
                  </p>
                  <Button variant="outline" size="sm" className="mt-2" data-id="element-1335">
                    Contact Customer
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
};
export default OrderManagement;